import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useStoryView } from 'store/main_book_popup/selectors';
import { useOneStoryWithAi } from 'store/StoryAiCofig/selectors';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { handleListStoryById } from 'store/StoryAiCofig/thunks';
import Loading from './Loading';
import COLOR from 'utils/constants/color';

const AssignmentPlanInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;

const AssignmentPlan = styled.button`
  background-image: linear-gradient(to right, ${COLOR.indigo500}, ${COLOR.indigo600});
  border: 1px solid #020A52;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 27.2px;
  color: white;
  z-index: 1;
  padding: 1px;
  font-size: 12.1px;
  font-weight: 400;
  margin-left: 8px;
  white-space: nowrap;

  @media only screen and (max-width: 1367px) {
    margin-top: 5px;
  }
`;

const ShowStoryBtn = ({ storyInstruction }) => {
  const dispatch = useDispatch();
  const { invokeStoryView } = useStoryView();
  const { checkPopUpAtOnce, updatePopUpAtOnce } = usePopUpAtOnce();
  const book_story = useOneStoryWithAi();
  const [storyAILoader, setStoryAILoader] = useState(false);

  const fetchStoryAI = async (type) => {
    if (checkPopUpAtOnce() && type === "clickEvent") {
      return;
    }
    if (type === "clickEvent") {
      updatePopUpAtOnce(true);
    }
    setStoryAILoader(true);
    if (Array.isArray(book_story) && book_story.length > 0) {
      const has_soy_story = book_story.find((story) => story.id === storyInstruction);
      if (has_soy_story && has_soy_story?.id) {
        invokeStoryView(has_soy_story, "story");
        setStoryAILoader(false);
        return;
      }
    }
    const result = await dispatch(
      handleListStoryById(storyInstruction)
    );
    setStoryAILoader(false);
    if (result && result?.id) {
      invokeStoryView(result);
    }
  };

  if (!storyInstruction) return null;

  return (
    <AssignmentPlan onClick={() => fetchStoryAI("clickEvent")}>
      <AssignmentPlanInner>
        {storyAILoader ? <Loading size={16} white /> : 'View Story'}
      </AssignmentPlanInner>
    </AssignmentPlan>
  );
};

export default ShowStoryBtn;
